module.exports = __webpack_public_path__ + "img/empty.b2bd8573.svg";